module.exports = __webpack_public_path__ + "img/gq.385ac47.svg";